import React from 'react';
import { useI18n } from '../../hooks/useI18n';
import { DocumentType } from '../../types/cabinet.types';

export type DocFilterTab = 'all' | DocumentType;

interface DocumentTabsProps {
  activeTab: DocFilterTab;
  onChangeTab: (tab: DocFilterTab) => void;
  className?: string;
}

export const DocumentTabs: React.FC<DocumentTabsProps> = ({ activeTab, onChangeTab, className = '' }) => {
  const { t } = useI18n();

  const tabs: { id: DocFilterTab; labelDesktop: string; labelMobile: string }[] = [
    { id: 'all', labelDesktop: t('doc_all_files'), labelMobile: t('doc_all') },
    { id: 'recepta', labelDesktop: t('doc_recepty'), labelMobile: t('doc_recepty') },
    { id: 'skierowanie', labelDesktop: t('doc_skier'), labelMobile: t('doc_skier') },
    { id: 'wyniki', labelDesktop: t('doc_wyniki'), labelMobile: t('doc_wyniki') },
    // { id: 'l4', labelDesktop: t('doc_l4'), labelMobile: t('doc_l4') }
  ];

  return (
    <div className={`cab-doc-tabs-wrap ${className}`}>
      <div className="cab-doc-tabs">
        {tabs.map(tab => (
          <button
            key={tab.id}
            className={`cab-dt-btn ${activeTab === tab.id ? 'active' : ''}`}
            onClick={() => onChangeTab(tab.id)}
          >
            <span className="cab-tab-desktop">{tab.labelDesktop}</span>
            <span className="cab-tab-mobile">{tab.labelMobile}</span>
          </button>
        ))}
      </div>
      <style>{`
        .cab-tab-mobile { display: none; }
        
        .cab-doc-tabs-wrap {
          margin: 16px -16px 30px;
          padding: 0 16px;
          overflow-x: auto;
          scrollbar-width: none;
        }
        .cab-doc-tabs-wrap::-webkit-scrollbar {
          display: none;
        }
        .cab-doc-tabs {
          display: inline-flex;
          gap: 12px;
          padding-bottom: 4px;
        }
        .cab-dt-btn {
          height: 38px;
          padding: 0 20px;
          border-radius: 100px;
          border: none;
          background: #fff;
          color: #8C7D9B;
          font-weight: 600;
          font-size: 14px;
          white-space: nowrap;
          cursor: pointer;
          transition: 0.2s;
          font-family: inherit;
        }
        .cab-dt-btn:hover {
          background: #F4F0FA;
        }
        .cab-dt-btn.active {
          background: #E6D6FA;
          color: #361777;
        }

        @media (max-width: 1024px) {
          .cab-tab-desktop { display: none; }
          .cab-tab-mobile { display: inline; }
          
          .cab-dt-btn.active {
            background: #361777; /* Dark purple for active tab on mobile */
            color: #ffffff;
          }
          .cab-dt-btn {
            color: #361777; /* Dark purple text for inactive tabs on mobile */
          }
          .cab-doc-tabs-wrap {
            margin-bottom: 20px;
          }
          .cab-doc-tabs {
          gap: 2px;
          }
        }
      `}</style>
    </div>
  );
};
